module.exports = __webpack_public_path__ + "img/h&s2.3d15ca55.jpeg";